import React from 'react';
import './HomeEvents.css';
import map1Image from '../map1.jpeg';
import schoolIcon from '../school.png';
import arrowIcon from '../arrow.png';

const HomeEvents = () => {
  return (
    <section className="home-events-section">
      <div className="container">
        <div className="home-events-content">
          <div className="home-events-text">
            <div className="home-events-header">
              <h2 className="home-events-title">Events</h2>
            </div>
            
            <p className="home-events-description">
              The Sanatan Jagaran Rashtra Kalyan Yagya Yatra is a monumental Vedic spiritual 
              initiative dedicated to the revival of Sanatana Dharma, national welfare, and 
              collective spiritual awakening. Organized on the auspicious occasion of the 200th 
              Birth Anniversary of Maharshi Dayanand Saraswati, this sacred Yatra symbolizes a 
              return to Vedic values through disciplined spiritual practice and social responsibility.
            </p>
            
            <p className="home-events-description">
              The Yagya Yatra begins at Rameshwaram and culminates at Srinagar, covering 
              approximately 6,600 kilometers across 16 states of India. Conducted from 14 
              January 2026 to 24 February 2026, the journey includes Vedic Yagyas, mantra 
              chanting, Agni worship, and the establishment of Akhand Jyoti through Arani 
              Manthan at key locations. These rituals are performed according to authentic Vedic 
              traditions under the guidance of learned Acharyas.
            </p>
            
            <p className="home-events-description">
              The Yatra emphasizes harmony between spirituality and material life, promoting 
              discipline, selfless service, environmental purification, and moral responsibility. 
              Through Yagya, it seeks to remove negativity, foster charity and hard work, and 
              inspire individuals to follow the path of Dharma. The Sanatan Jagaran Rashtra Kalyan 
              Yagya Yatra stands as a powerful movement to awaken spiritual consciousness and 
              strengthen cultural and national values for the well-being of society and the nation.
            </p>
            
            <button className="home-events-btn">
              <img src={schoolIcon} alt="School" className="btn-icon-left" />
              <span className="btn-text">Explore More</span>
              <img src={arrowIcon} alt="Arrow" className="btn-icon-right" />
            </button>
          </div>
          
          <div className="home-events-image">
            <img src={map1Image} alt="Yatra Route Map" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeEvents;